import { Navigate, Outlet, useOutletContext } from 'react-router-dom';

import useAuth from '@/hooks/use-auth';

const RoleProtectedRoute = ({ allowedRoles }: { allowedRoles: string[] }) => {
  const { userRoles } = useAuth();

  const context = useOutletContext();

  const hasPermission = userRoles?.some((role) => allowedRoles.includes(role));

  if (!hasPermission) {
    return <Navigate to="/home" replace />;
  }

  return <Outlet context={context} />;
};

export default RoleProtectedRoute;
